import { render, staticRenderFns } from "./TutorialNote.vue?vue&type=template&id=65f3d63b&scoped=true&"
import script from "./TutorialNote.vue?vue&type=script&lang=js&"
export * from "./TutorialNote.vue?vue&type=script&lang=js&"
import style0 from "./TutorialNote.vue?vue&type=style&index=0&id=65f3d63b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f3d63b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VTextarea})
